import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCamera12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCamera12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 4h4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5M1 4.5A1.5 1.5 0 0 1 2.5 3h4A1.5 1.5 0 0 1 8 4.5v.566l2.223-1.482A.5.5 0 0 1 11 4v4a.5.5 0 0 1-.777.416L8 6.934V7.5A1.5 1.5 0 0 1 6.5 9h-4A1.5 1.5 0 0 1 1 7.5zM8.401 6 10 7.066V4.934z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCamera12);
